module.exports = __webpack_public_path__ + "static/media/img-loader.2b48cb93.svg";